import React, { useState } from "react";
import { Button, 
  LinearProgress, 
  makeStyles ,
  Box,
  Typography,
  TextField,
  Avatar,
  IconButton,
  Card,
  Modal,

 } from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { CircularProgress } from "@material-ui/core";
import { CircularLoader } from "../../../components/widgets/CircularLoader";
import { ErrorText } from "../../../components";
import { doc, setDoc } from "firebase/firestore";
import { storage } from "../../../config/firebase.js";
import { db } from "../../../config/firebase";
import { COLLECTION } from "../../../data/constant";
import icon from '../../../assets/Images/profile.png'
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { updateDoc } from "firebase/firestore";
import { Timestamp } from "firebase/firestore"; // Make sure this is imported


const customStyle = makeStyles((theme) => ({
root: {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  width: "100%",
  margin: "0 auto",
  padding: "20px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "center",
  },
},
leftSide: {
  flex: 1,
  marginRight: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    marginRight: 0,
    marginBottom: "20px",
  },
},
rightSide: {
  flex: 2,
  display: "flex",
  flexDirection: "column",
  marginLeft: "20px",
  [theme.breakpoints.down("sm")]: {
    marginLeft: 0,
  },
},
box: {
  border: "1px solid #ccc",
  padding: "20px",
  borderRadius: "8px",
  marginBottom: "20px",
  width: "600px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
},
boxLeft: {
  border: "1px solid #ccc",
  padding: "20px",
  borderRadius: "8px",
  marginBottom: "20px",
  width: "300px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
},
boxLeftProfile: {
  border: "1px solid #ccc",
  padding: "20px",
  borderRadius: "8px",
  marginBottom: "20px",
  textAlign: "center",
  width: "300px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
},
userDetails: {
  marginTop: "20px",
  textAlign: "left",
},
userDetailsLeft: {
  marginTop: "20px",
  alignItems: "center",
},
inputPlaceholder: {
  color: "#aaa", // Adjust the color to your preference
},
actionBtn: {
  marginTop: "10px",
},
gap: {
  marginLeft: "10px", // Adjust the margin as needed
},
profileIcon: {
  height: "100px"
},
completionMeterBox: {
  border: "1px solid #ccc",
  padding: "20px",
  borderRadius: "8px",
  marginBottom: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "600px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
},
completionMeter: {
  marginTop: "10px",
  width: "100%",
},
horizontalLine: {
  borderTop: "1px solid #ccc",
  margin: "10px ",
},
inputLabel: {
  // fontWeight: "bold",
  marginRight: "10px",
  marginTop: "10px", // Add margin-top to the labels
},
inputField: {
  marginBottom: "10px", // Add margin-bottom to the input fields
},

// Media Query for Extra Small Screens (<320px)
'@media (max-width: 319px)': {
root: {
  padding: "5px",
},
leftSide: {
  marginRight: "0px",
},
rightSide: {
  marginTop: "-15px",
  width: "90%",
  marginLeft: "-15px",
},
box: {
  marginTop: "-20px",
  width: "90%",
},
boxLeft: {
  marginTop: "-15px",
  width: "95%",
},
boxLeftProfile: {
  width: "95%",
},
completionMeterBox: {
  marginTop: "-15px",
  width: "90%",
  marginLeft: "0px",
},
inputLabel: {
  fontSize: "8px",
},
inputField: {
  fontSize: "14px",
},
profileIcon: {
  height: "80px",
},
},

// Media Query for Small Screens (320px - 480px)
'@media (min-width: 320px) and (max-width: 480px)': {
root: {
  padding: "10px",
},
leftSide: {
  marginRight: "0px",
},
rightSide: {
  marginTop: "-10px",
  width: "78%",
  marginLeft: "-25px",
},
box: {
  width: "95%",
  marginTop: "-15px",
},
boxLeft: {
  width: "95%",
  marginTop: "-10px",
},
boxLeftProfile: {
  width: "95%",
},
completionMeterBox: {
  width: "95%",
},
inputLabel: {
  fontSize: "10px",
},
inputField: {
  fontSize: "16px",
},
profileIcon: {
  height: "90px",
},
},

// Media Query for Medium Screens (481px - 768px)
'@media (min-width: 481px) and (max-width: 768px)': {
root: {
  padding: "15px",
},
leftSide: {
  marginRight: "10px",
},
rightSide: {
  marginTop: "-5px",
  width: "75%",
  marginLeft: "0px",
},
box: {
  width: "95%",
  marginTop: "-10px",
},
boxLeft: {
  width: "90%",
  marginTop: "-5px",
},
boxLeftProfile: {
  width: "90%",
},
completionMeterBox: {
  width: "90%",
},
inputLabel: {
  fontSize: "12px",
},
inputField: {
  fontSize: "17px",
},
profileIcon: {
  height: "95px",
},
},

// Media Query for Large Screens (769px - 1024px)
'@media (min-width: 769px) and (max-width: 1024px)': {
root: {
  padding: "20px",
},
leftSide: {
  width: "75%",

},
rightSide: {
  width: "75%",
  marginLeft:"-30px"
},
box: {
  width: "100%",
},
boxLeft: {
  width: "100%",
},
boxLeftProfile: {
  width: "100%",
},
completionMeterBox: {
  width: "100%",
},
inputLabel: {
  fontSize: "14px",
},
inputField: {
  fontSize: "18px",
},
profileIcon: {
  height: "100px",
},
},
}));


const Layout = ({ userData, userId, loading ,podData}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [editedUserData, setEditedUserData] = useState(userData);
  const [profilePicture, setProfilePicture] = useState(null); 
  const classes = customStyle();
  const [isEditingPpin, setIsEditingPpin] = useState(false);
  const [activeTab, setActiveTab] = useState('My Pod');

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [formData, setFormData] = useState({});

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleChangePasscode = async () => {
    if (!formData.passCode) return alert("Password cannot be empty!");

    try {
      const userDocRef = doc(db, COLLECTION.PUSERS, userId);
      await updateDoc(userDocRef, {
        passCode: formData.passCode,
      });

      console.log("Password updated successfully");
      setIsPasswordModalOpen(false);
      setFormData({});
      window.location.reload(); // Optional
    } catch (error) {
      console.error("Error updating password:", error);
    }
  };


  const handleSaveProfile = async () => {
    try {
      let photoURL = editedUserData.photoURL;
  
      if (profilePicture) {
        const storageRef = ref(
          storage,
          `userPhotos/${userId}-${profilePicture.name}`
        );
        const uploadTask = await uploadBytesResumable(storageRef, profilePicture);
        photoURL = await getDownloadURL(uploadTask.ref);
      }
  
      const userDocRef = doc(db, COLLECTION.PUSERS, userId);
      await updateDoc(userDocRef, {
        ...editedUserData,
        photoURL,
        updatedTimestamp: Timestamp.now(),
      });
  
      setIsEditModalOpen(false);
      window.location.reload(); // Optional for refreshing UI
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };
  
  
  if (loading) {
    return <CircularLoader />;
  }

  if (!userData) {
    return <ErrorText />;
  }

  const tabData = {
    'My Profile': {
     'Full Name':userData.userName,
      'Phone Number' : userData.userId,
      'Pass Code' : userData.passCode,
      'Email Address': userData?.email || 'unavailable',
      'Transactions' : userData.transactionsCount,
      'Creation Date': userData.createdTimestamp
      ? new Date(userData.createdTimestamp * 1000).toLocaleString('en-IN', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      : 'N/A',
    },
    'My Pod': {
      '	Pod Identifier': podData?.ppodNumber || 'unavailable',
      'Pod Location': podData?.location || 'unavailable',
    },
    'My Plan': {
      'Subscription Plan': userData.planName || 'Starter Plan',
      'Billing Amount': userData.planPrice || '₹199/month',
      'Next Renewal Date': userData.renewalDate || 'N/A',
    },
  };

  

  return (
    
    <div  className={classes.root}>

      <Box  sx={{backgroundColor: '#f8fbfd',gap: 1,p: 2,width: '95%'}}>

      <Box sx={{display: 'flex',justifyContent: 'space-evenly',alignItems: 'flex-start',flexWrap: 'wrap',gap: 2,p: 3,backgroundColor: 'white',borderRadius: 2,width: '95%'}}>
      
      <Box >
      <img
  src={userData.photoURL || icon}
  alt="User Avatar"
  style={{
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '3px solid white',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.15)',
    marginLeft:"-40px"
  }}
/>
  </Box>

  <Box sx={{ minWidth: 200, marginTop: "10px" ,marginLeft:"-30px"}}>
  <Typography
    style={{
      fontWeight: 'bold',
      color: 'black',
      fontFamily:"Inter, sans-serif",
      fontSize: '24px'  // 👈 Adjusted font size
    }}
  >
    <b>{userData.userName}</b>
  </Typography>
  <Typography
    style={{
      
      fontFamily: 'DM Sans, sans-serif',
      fontSize: '16px',  // 👈 You already had this one set
    marginTop:"20px"
    }}
  >
  {userData.userId} | {userData.email ? userData.email : "NA"}
  </Typography>
</Box>


  <Box sx={{ minWidth: 200 ,display: 'flex',justifyContent: 'space-evenly',alignItems: 'flex-start',flexWrap: 'wrap',gap: 30,p: 2,marginTop:"60px"}}>
    
        <Button variant="contained" style={{ textTransform: 'none' ,fontFamily: 'Inter, sans-serif',backgroundColor:"#8b003c",color:"white",'&:hover': {
          backgroundColor: '#8b003c', // keep background same
          color: 'white',             // prevent text turning blue
        },
      }} 
      onClick={() => setIsPasswordModalOpen(true)}
      >
        <b>Change Passcode</b>
        </Button>
        <Button variant="contained" style={{ textTransform: 'none' ,fontFamily: 'Inter, sans-serif',backgroundColor:"#8b003c",color:"white",'&:hover': {
          backgroundColor: '#8b003c', // keep background same
          color: 'white',             // prevent text turning blue
        },
      }} 
      onClick={() => {
        setEditedUserData(userData);
        setProfilePicture(null);
        setIsEditModalOpen(true);
      }}
      >
        <b>Edit Profile</b>
        </Button>
  </Box>
  
  </Box>
  <Box sx={{display: 'flex',marginTop:"20px",alignItems: 'flex-start',flexWrap: 'wrap',gap: 2,p: 3,borderRadius: 2,width: '95%'}}>
 {/* LEFT SIDEBAR */}
 <Box
        sx={{
          minWidth: 150,
          borderRadius: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 2,
          fontFamily:"Inter",
          background: `radial-gradient(circle at 0% 0%,#f3f3f3 0%, #f3f3f3 100%)`,

        }}
      >
        {Object.keys(tabData).map((label) => (
          <Box
            key={label}
            onClick={() => setActiveTab(label)}
            sx={{
              padding: '10px 15px',
              backgroundColor:
                activeTab === label ? '#e6e6e6' : '#f3f3f3',
              color:
                activeTab === label ? 'black' : 'gray',
              borderRadius: 6,
              textAlign: 'center',
              fontWeight: 'bold',
              fontFamily: "Source Sans Pro",
              cursor: 'pointer',
            }}
          >
            {label}
          </Box>
        ))}
      </Box>

      {/* RIGHT CARD */}
    
                <Card
            style={{
              marginTop: "-5px",
              marginLeft: "40px",
              flex: 1,
              height: "auto",
              maxWidth: "350px",
              padding: 20,
              borderRadius: 10,
              boxShadow: 3,
              backgroundColor: "#f7f7f7",
              fontFamily:"DM Sans, sans-serif"
              
            }}
          >
            {Object.entries(tabData[activeTab]).map(([key, value]) => {
              const isMapLink = typeof value === 'string' && value.includes('maps.app.goo.gl');

              return (
                <Box key={key} sx={{ mb: 2 }}>
                  <Typography sx={{ fontSize: '14px' }}>
                    <strong>{key}:</strong>{' '}
                    {isMapLink ? (
                      <a
                        href={value}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#1976d2',
                          textDecoration: 'none',
                          fontWeight: 500,
                        }}
                      >
                        📍 View Location on Map
                      </a>
                    ) : (
                      value || '—'
                    )}
                  </Typography>
                </Box>
              );
            })}
          </Card>


</Box>

     </Box>
   
     <Modal open={isPasswordModalOpen} onClose={() => setIsPasswordModalOpen(false)}>
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" style={{marginLeft:"100px"}}>
            Change Passcode
          </Typography>

          <TextField
            fullWidth
            type="password"
            label="New Password"
            variant="outlined"
            margin="normal"
            name="passCode"
            value={formData.passCode || ''}
            onChange={handleInputChange}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 12 }}>
            <Button variant="contained" onClick={() => setIsPasswordModalOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleChangePasscode}
              style={{ backgroundColor: '#8b003c', color: 'white' }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
  <Box
    sx={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      borderRadius: 10,
      boxShadow: 24,
      p: 4,
    }}
  >
    <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
      Edit Profile
    </Typography>

    {/* Profile Image */}
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
      <Avatar
        src={
          profilePicture
            ? URL.createObjectURL(profilePicture)
            : editedUserData.photoURL || icon
        }
        alt="Profile"
        sx={{ width: 80, height: 80 }}
      />
    </Box>

    <Box sx={{ textAlign: 'center'}}>
      <Button variant="outlined" component="label"  sx={{textTransform: 'none'}}>
        Choose New Image
        <input
          hidden
          accept="image/*"
          type="file"
          onChange={(e) => setProfilePicture(e.target.files[0])}
        />
      </Button>
    </Box>

    {/* Editable Fields */}
    <TextField
      fullWidth
      label="Full Name"
      name="userName"
      value={editedUserData.userName}
      onChange={(e) =>
        setEditedUserData({ ...editedUserData, userName: e.target.value })
      }
      margin="dense"
    />
    <TextField
      fullWidth
      label="Email"
      name="email"
      value={editedUserData.email}
      onChange={(e) =>
        setEditedUserData({ ...editedUserData, email: e.target.value })
      }
      margin="dense"
    />

    <TextField
      fullWidth
      label="Phone Number"
      name="userId"
      value={editedUserData.userId}
      disabled
      margin="dense"
    />

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, gap: 16 }}>
      <Button variant="contained" onClick={() => setIsEditModalOpen(false)}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={async () => await handleSaveProfile()}
        style={{ backgroundColor: '#8b003c', color: 'white' }}
      >
        Save
      </Button>
    </Box>
  </Box>
</Modal>

    </div>
    
  );
};

export default Layout;
